import React, { Component } from 'react';
import { Field } from 'react-form';
import imgPlaceholder from '../../assets/img/img-placeholder.png';
import { validate } from '../../utils/validation';


class ImageUpload extends Component {

    state = {
        imagePreviewUrl: this.props.defaultImage
    };

    onImageChoose = (e, setValue) => {
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({
                file: file,
                imagePreviewUrl: reader.result
            });
            if (file.type.indexOf('image') === -1) {
                this.setState({
                    file: null,
                    imagePreviewUrl: null
                });
            } else {
                this.setState({
                    file: file,
                    imagePreviewUrl: reader.result
                });
            }

            setValue(reader.result);

        };

        reader.readAsDataURL(file);

    };

    render() {
        return (
            <React.Fragment>
                <div className="image-upload size-md my-20">
                    <p className="color-grey50 font-sm w-700">{this.props.label}</p>
                    <div className="image mt-10">
                        <img src={ this.state.imagePreviewUrl ? this.state.imagePreviewUrl : imgPlaceholder } alt="placeholder"/>

                    </div>
                    <div className="upload-meta mt-10 text-field">
                        <label>
                            <Field validate={ value => validate(value, this.props.validations) } field="image">
                                { fieldApi => {
                                    const { setValue, error } = fieldApi;
                                    return (
                                        <React.Fragment>
                                            <input type="file" hidden onChange={(e) => this.onImageChoose(e, setValue)} />
                                            { error ?  <span className="error-msg mb-10" >{ error }</span> : null }
                                        </React.Fragment>
                                    );
                                }}
                            </Field>
                            <span style={{color: 'red'}}></span>
                            <p className="flex-align-y font-sm w-800"><i className="fa fa-upload mr-10"></i>{this.state.imagePreviewUrl ? 'Change' : 'Choose'} File</p>

                        </label>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ImageUpload;




// WEBPACK FOOTER //
// ./src/components/UI/ImageUpload.js